import React from 'react';
//import AuthService from '../Services/auth.service';
import {   Modal,ModalHeader, ModalBody } from "reactstrap";
//import ReactHtml from 'raw-html-react';
import ReactLoading from 'react-loading';
import './Cart.css';
import AuthService from '../Services/auth.service';
import CartService from '../Services/cart.service';
import Cartitems from '../Components/Cartitems';
import Emptycart from '../Components/Emptycart';
import Address from '../Pop-up/Address';
import Loader from '../Components/Loader';
import toast, { Toaster } from 'react-hot-toast';
import Alertsuccess from '../Pop-up/Alertsuccess';
class Cart extends React.Component {

  constructor(props){
       
    super(props);
    this.state = {
      cartItems: [],
      cartTotal: [],
      cartGrandTotal: [],
      optinItems: [],
      address:[],
      deliveryslot:[],
      loggedIn:false,
      addModal:false,
      shipAddress:[],
      shipAddressName:undefined,
      addressLoader:'',
      checkoutLoader:'Checkout',
      orderDetails:[],
      razorOrder:[],
      paymentPopup:false,
      addressStatus:false,
      orderStatus:false,
      cartEmpty:false,
      coupon_code:undefined,
      delivery_charge:[],
      discount_amount:0,
      delivery_details:[],modal:false,
      check:true,
      currentAddress:'',alert:false,
      modal3:false


  }
  this.getCart = this.getCart.bind(this)
  this.handleUpdate = this.handleUpdate.bind(this)
  this.handleOptinUpdate = this.handleOptinUpdate.bind(this)

}
async componentDidMount(){
  this.getCart()
}

async getCart(){
const USR_TOKEN = localStorage.getItem("userToken")

if(USR_TOKEN){
  this.setState({loggedIn:true})
  
  await CartService.getCart()
  .then(response=>{ 
      //console.log("getCart")
     //alert("ok")
      if(response['doc']['items'].length < 1){
        this.setState({cartEmpty:true})
      }else { this.setState({cartEmpty:false}) }

      this.setState({cartItems:response['doc']['items']})
      this.setState({cartTotal:response['doc']['total']})
      this.setState({cartGrandTotal:response['doc']['grand_total']})
      this.setState({deliveryslot:response['delivery_slots'][0]})
      this.setState({delivery_charge:response['doc']['taxes']})

      if(response['doc']['shipping_address']){
        this.setState({address:response['doc']['shipping_address']})
        this.setState({addressStatus:true})

        if(response['shipping_charges'])
        {
          this.setState({delivery_details:response['shipping_charges']})
          this.setState({ checkoutLoader:'Checkout'});
        }
    }
      
      this.setState({shipAddress:response['shipping_addresses']})
      this.setState({shipAddressName:response['doc']['shipping_address_name']})
      this.setState({coupon_code:response['doc']['coupon_code']})
      this.setState({discount_amount:response['doc']['base_discount_amount']})
      this.setState({check:false})
  })
  .catch(err=>{ console.log(err)
    toast.error("Something wrong please logout your profile !")
    //alert("Something wrong please logout your profile !")
  })
  
}
else{
  
  
    let cart = AuthService.getCartitems()
    let count = cart
    //this.setState({check:false})
    if(count == null){
      // alert(1)
       this.setState({cartEmpty:true})
       this.setState({check:false})
     }
     else {
      
        this.setState({cartEmpty:false})
        this.setState({check:false}) 
       // alert("ok")
     }
      if(cart.length < 1){
       //alert(2)
        this.setState({cartEmpty:true})
        this.setState({check:false})
      }
      else {
       
         this.setState({cartEmpty:false})
         this.setState({check:false}) 
        // alert("ok")
      }
     
    if(cart){
        this.setState({cartQty:cart.length})
        let total = parseFloat(0.00);
        if(cart.length > 0){
         // alert("ok")
            for (let itm in cart) {
                total += parseFloat(cart[itm]['rate']*cart[itm]['qty']);
            } 
        }
        this.setState({cartTotal:total})
        this.setState({cartItems:cart})
       
        this.setState({cartGrandTotal:parseFloat(total) })
        this.setState({check:false})
    }
   

}
CartService.update_cart()

}
async appyCoupn(){
alert("Coupn")
} 
    
handleUpdate(e) {
this.setState({cartItems:[]})
this.getCart()
// CartService.update_cart()
}
handleOptinUpdate(e) {
  this.setState({cartItems:[]})
  this.getCart()
    //this.getCart()
  // CartService.update_cart()
}
addressPop() {
  
this.setState({ addModal: true });
}


async selectAddress(e, add_name,pincode ){
if(this.state.cartItems.length > 0){
  this.setState({ addressLoader: <ReactLoading type="bars" color="#000" height={50} width={35} /> });
  this.setState({ shipAddressName: add_name });
  await CartService.setAddress(add_name,pincode)
  .then(res=>{  
    //alert(pin)
      this.setState({ addressLoader: '' }); 
      this.getCart()
      this.setState({addressStatus:true})
      this.setState({ addModal: false });
      //localStorage.setItem("tempPin", pin)
     // this.setState({ currentAddress:pin });
  })
}
}
loginClick = (e) => {
  var link = document.getElementById('loginLink');
  link.click();
}
async checkOut(e){

let stat = true
if(!this.state.loggedIn){
 
  this.alertOpen(e)
  /* alert("Please Login to proceed !") */
   this.loginClick()
   stat =false
}
if(!this.state.addressStatus && this.state.loggedIn){
   //alert("Please add shipping address to continue") 
   toast.error("Please add shipping address to continue")
   stat =false
}
if(!this.state.cartItems.length > 0){
   //alert("Your Cart is empty")
   toast.error("Your Cart is empty")
   stat =false
}
//if(!this.state.delivery_details.name){
    //alert(this.state.delivery_details.name)
  // alert("Delivery Not available for the selected address.")
  // stat =false
// }

if(this.state.loggedIn && stat){

//alert(localStorage.getItem('tempPin'))
      if(localStorage.getItem('tempPin')==localStorage.getItem('pin')){
          // const user =  AuthService.getCurrentUser();
            this.setState({ checkoutLoader:'Proccessing Order...'});
            window.location.href = "/payment"
            /*await CartService.place_order()
            .then(res=>{  
                  console.log(res)

                  this.setState({ orderDetails:res});
                
                  var options = {
                    "key": 'rzp_test_v6nWNOJTSKQ7nu',
                    "name": "",
                    "description": "",
                    'order_id':"",
                    "handler": function(response) {
                        console.log(response);
                        var values ={
                            razorpay_signature : response.razorpay_signature,
                            razorpay_order_id : response.razorpay_order_id,
                            transactionid : response.razorpay_payment_id                }
                        
                    },
                    "prefill":{
                        "name":user.full_name,
                        "email":user.email,
                        "contact":user.mobile_no,
                    },
                    "notes": {
                      "address": this.state.address
                    },
                    "theme": {
                      "color": "#528ff0"
                    }
                  };

                  
                  console.log("res.data.id")
                  console.log(res.message.id)
                  if(res.message.id){
                      this.setState({ checkoutLoader:'Order Placed.'});
                    

                      localStorage.setItem("orderID", res.message.id);
                      window.location.href = "/payment.html"
                    
                  }
                  

            })*/
           // localStorage.removeItem("tempPin");

          }
      else {
        alert(localStorage.getItem('tempPin') + localStorage.getItem('pin'))
        //this.setState({ alert: <BasicAlert /> }),
        toast.error("This item cannot be shipped to your selected delivery location. Please choose a different delivery location")
       // alert("This item cannot be shipped to your selected delivery location. Please choose a different delivery location")
       await new Promise(resolve => setTimeout(resolve, 1000));

        this.setState({ addModal: true })
      }

    //setTimeout(() => {  console.log("World!"); }, 2000);
}



}
 modalOpen(e) {
    e.preventDefault()
    this.setState({ modal: true });
  }
modalClose= () =>  {
this.setState(prevState => ({
addModal: !prevState.addModal
}));
}
alertOpen(e){
  e.preventDefault()
  this.setState({ modal3: true });

}
alertCancel= () =>  {
  this.setState(prevState => ({
  modal3: !prevState.modal3
  }));
  }
handleClose= () =>  {
  this.setState(prevState => ({
  modal: !prevState.modal
  }));
  }
render() {
  //var TempPin =localStorage.getItem("tempPin", pin);
//alert(localStorage.getItem('tempPin'))
  const rawHTML =this.state.address;
  let tax =0
  if(!this.state.address){
    this.setState({ address:'Please add shipping address'});
  }

  if(this.state.cartEmpty){
    return <Emptycart />
  }
  else{

    return this.state.check ?  <Loader/> : <div>
    <div className="container mt-5 cart-page mb-5">
      <div className="row ">
      <Toaster
  position="top-center"
  reverseOrder={false}
/>
        <div className="col-md-8 ">

        
        {this.state.cartItems.map((itm,j)=>{
                              return(
                                <Cartitems itm={itm} key={j} handleUpdate={this.handleUpdate} />
                              )
                            })}
    
        
        {/*{this.state.optinItems.map((itm,k)=>{
          if(this.state.loggedIn && this.state.cartItems.length>0){
          return(*/}
              {/*<Optin  />*/}
            {/*})
          }
          else
              return null
        })}*/}
         </div>
          

            <div className="col-lg-4 center-block mb-5">
                    <div className=" res-address">
                      <h3 className="delivery-detials"> Delivery Address</h3>
                            <div className=" btn btn-outlines ouline-space width-335">
                            
                            {(() => {
                                    if (this.state.loggedIn) {
                                        return (<>
                                          {/* <div className="float-right"><p><CreateOutlinedIcon  aria-hidden="true" type="button" onClick={e => this.addressPop(e)}/></p></div> */}
                                          <div className="text-left"><p className="text-left" dangerouslySetInnerHTML={{ __html: rawHTML }} /></div>
                                          <p className=" mt-2 "><a href="#0" className="add-new-adres float-left" onClick={e => this.addressPop(e)}>select</a><a href="#0" className="add-new-adres float-right" onClick={e => this.modalOpen(e)}>Add</a></p>
                                          <Modal
                                              size="md"
                                              isOpen={this.state.addModal}
                                              toggle={() => this.setState({ addModal: false })} 
                                              show={this.state.addModal}
                                            /*  onHide={this.state.setPop} */
                                          >
                                          <ModalHeader toggle={() => this.setState({ addModal: false })}>
                                              <h3 className=" ml-2 address-titlt">Select Address</h3>
                                          </ModalHeader>
                                          <ModalBody>
                                          <div className="container ">
                                                {this.state.addressLoader}
                                                { this.state.shipAddress.map((itm,j)=>{
                                                    const rawHTML2 =itm.display
                                                  return(<div key ={j} onClick={e => this.selectAddress(e,itm.name,itm.pincode)}  className={(this.state.shipAddressName===itm.name)?"border-selected select-address btn btn-outlines col-12 ouline-space mr-2 close-green ": "select-address btn btn-outlines col-12 ouline-space mr-2  " } >
                                                        <h6 className="text-left"  dangerouslySetInnerHTML={{ __html: rawHTML2 }} />                                    
                                                  </div>)
                                                  })}
                                                   
                                            </div>
                                          </ModalBody>
                                          </Modal>
                                        </>)
                                    }  else {
                                    return (
                                      <p className="text-right total-price-small"><a href="#0" onClick={this.loginClick}>Not Logged In</a></p>)
                                    }
                              })()}
                    
                          
                            
                          </div> 
                        
                    </div>
            {/*<div className="container res-address">
              <h3 className="delivery-detials"> Delivery Slot</h3>
              <div className=" btn btn-outlines ouline-space width-335">
              {(() => {
                        if (this.state.loggedIn) {
                            let tm = this.state.deliveryslot
                            if(tm){
                            return (<> <div className="float-right "><p><a href="/#" onClick={e => this.slotPop(e)} className="greeen-pen"><CreateOutlinedIcon  aria-hidden="true" type="button" /></a></p></div>
                                    <h6 className="address-header delevry-address mt-2"><Moment format="dddd, DD MMMM yyyy" withTitle>{this.state.selectedSlot }</Moment>
                                    <br />  @ {tm[0].start_time} - {tm[0].end_time} 
                                    </h6>

                                    <Modal 
                                            size="md"
                                            isOpen={this.state.slotModal}
                                           toggle={this.handleClose} 
                                            show={this.state.slotModal}
                                             onHide={this.state.setPop}
                                        >
                                        <ModalHeader toggle={() => this.setState({ slotModal: false })}>
                                            <h3 className=" ml-2 address-titlt">Select slot</h3>
                                        </ModalHeader>
                                        <ModalBody>
                                        <div className="container ">
                                             
                                              <div  onClick={e => this.selectSlot(e)}  className="select-address btn btn-outlines col-12 ouline-space mr-2  "  >
                                                      <h6 className="text-left"><Moment format="dddd, DD MMMM yyyy" withTitle>23-3-1019</Moment></h6>                                     
                                                </div>
                                          </div>
                                        </ModalBody>
                                        </Modal>                                    
                                    
                                    </>
                                      )

                                      
                            }
                              
                            
                        }  else {
                        
                        return (
                          <p  className="text-right total-price-small">Not Logged In. <a href="/#" onClick={e => this.loginClick(e)}>Sign In</a> </p>)
                        }
                    })()}
                   
                    <h6 >Tomorrow,Sunday 13 December 2020</h6><br/>
                    <h6 className="address-header delevry-address">@04:00pm-06:00pm</h6><br/>
                </div>
                    
                  </div>*/}
            {/*{(() => {
                if (!this.state.coupon_code) {
                    return (<Coupondpdn handleUpdate={this.handleUpdate}/>)
                }
                else{
                    return( */}
                  {/*  {(() => {
                                  if (!this.state.coupon_code) {
                                      return (<Coupondpdn handleUpdate={this.handleUpdate}/>)
                                  }
                                  else{
                                      return( <div className="container coupn_section ">
                                                <h3 className="delivery-detials"> Coupon</h3>
                                                <div className=" btn btn-outlines ouline-space width-335 text-start">
                                      
                                                    <h5>Coupon Applied: <span>{this.state.coupon_code} </span></h5>  
                                                    <a href="/#" onClick={e => this.remvoveCoupon(e)}>Remove</a>
                                                </div>
                                              </div>)
                                  }
                              })()}
             */}
             {/* <div className="alert alert-success" role="alert">
                 <p className="mt-3"><strong>For fresh fish / fish products </strong>&nbsp;&nbsp;Order will be delivered before 10:00 AM tomarrow</p>
                 
             </div> */}
            <div className="  mt-5 res-address">
            <h3 className="delivery-detials">Cart Charges</h3>
                <div className="cart-total ml-3 mr-3 copn-inpt-box res-cart-center">  
            <ul className="subtotal-list copn-inpt-box res-cart-charge">
                            <li className="float-price-right total-price-small bottom-space-small ">Sub-Total<span className="">₹  {this.state.cartTotal}</span></li>
                            {/*<li className="float-price-right total-price-small bottom-space-small ">Wallet<img src="/assets/images/coin-icon.png" className="my-coin pl-1" alt="" title=""/><a className="bit-coin pl-1" href="/wallet.html" >Add Money</a><span className=" ">- Rs 0</span></li>*/}
                            {(() => {

                                if (this.state.discount_amount > 0) {
                                      return (<li className="float-price-right total-price-small bottom-space-small">Discount<span className=" ">₹ {this.state.discount_amount}</span></li>)
                                
                                }else
                                    return ("")

                          })()}
                            {this.state.delivery_charge.map((itmd,j)=>{ 
                                if(itmd.account_head ){
                                  return( <li key={j} className="float-price-right total-price-small bottom-space-small">Delivery Charges <span className=" ">₹ {itmd.tax_amount}</span></li>)
                                }
                                else{
                                      tax = tax +  itmd.tax_amount
                                      console.log(tax)
                                      return ""
                                }
                            })}
                            


                            <li className=" float-price-right total-price col-12">Total<span className=" ">₹ {this.state.cartGrandTotal}</span></li>
                        </ul>
                </div>
              <button type="button" className="delevry-charge add-to-cart2 btnn-wide mt-3 chcek-out-btn text-center cp" onClick={e => this.checkOut(e)}>{this.state.checkoutLoader}</button></div>
        </div>    
      
                      <Modal
                                size="md"
                                isOpen={this.state.modal}
                                toggle={this.handleClose}
                                show={this.state.modal}
                               /*  onHide={this.state.setPop} */
                            >
                             <ModalHeader toggle={() => this.setState({ modal: false })}>
                            </ModalHeader>
                            <ModalBody>
                                    <Address path="cart" currentLocation={this.state.currentLocation}  modalClose={this.handleClose} handleCancel={this.handleClose} /* DataSubmit={this.dataSubmit()} */ />

                            </ModalBody>
                          
                      </Modal>
    
      </div>

     
                            <Modal
                                size="md"
                                isOpen={this.state.modal3} 
                                toggle={() => this.setState({ modal3: false })}
                                show={this.state.modal3}
                                centered
                            >
                            <ModalBody className="alert-success-img">
                                    <Alertsuccess alertcancel={this.alertCancel} alertmessage="Please Signup"/>

                            </ModalBody>
                          
                          </Modal>
    </div>
    <div className="clearfix"></div>
    
    </div>
    

  }
}

}


export default Cart;

